import React, { Component } from "react";
import {Grid, GridColumn, GridToolbar, GridNoRecords} from '@progress/kendo-react-grid';
import { process, filterBy } from '@progress/kendo-data-query';
import axios from 'axios';
import Popup from "reactjs-popup";
import { Button } from '@progress/kendo-react-buttons';
import AddHouseholdAccount from "./AddHouseholdAccount";
import AddHouseholdAccountNoPositions from "./AddHouseholdAccountNoPositions";
import GridLoading from "../../Loaders/GridLoading";
import { Switch } from "@progress/kendo-react-inputs";

class HouseholdAccounts extends Component {

    constructor(props) {
    super(props);

    this.state = {
        household:this.props.dataRow.GroupCode,
        company:this.props.user.company,
        mappings:[],
        result:[],
        loading:false,
        dataState:{sort:[{field:'MemberOrder', dir:'asc'}]},
        refreshText:'',
        addAccountMappingLoading: false,
        addAccountMappingText: "Add Account Mapping",
        fileSelected: false,
        unsavedChanges: false
      }
      
      this.getHouseholdMappings=this.getHouseholdMappings.bind(this);
      this.clearState=this.clearState.bind(this); 
      this.onCloseModal=this.onCloseModal.bind(this); 
      this.refresh = this.refresh.bind(this);
  }


  componentDidMount(){
  }

  
  componentWillUnmount() {
    this.clearState();
  }
  
  refresh(){
    this.getHouseholdMappings();
  }

  selectionChange(event, gFiles) {
    gFiles.forEach(item => {
        if (item.MemberCode !== event.dataItem.MemberCode) {
            item.selected = false
        }
    });
    event.dataItem.selected = !event.dataItem.selected;
    var selectedFiles = [];
    for (let i = 0; i < gFiles.length; i++) {
      if (gFiles[i].selected) {
        selectedFiles.push(gFiles[i]);
      }
    }
    this.setState({ fileDownload: selectedFiles });
    if (selectedFiles.length > 0) {
      this.setState({ fileSelected: true });
    }
    else {
      this.setState({ fileSelected: false });
    }
    this.forceUpdate();
  }

  getHouseholdMappings(){
    const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    
    this.setState({loading:true, refreshText:'Loading...'});

    // axios.get('api/groupMembershipEntity' , payload , {headers})
    axios(`api/groupMembershipEntity`, {
      method: 'GET',
      params: { company: this.props.user.company,groupCode:this.props.dataRow.GroupCode },
      headers: headers,
    })
    .then(response=>{
      for (let i = 0; i < response.data.data.length; i++){
        response.data.data[i].id = Math.random()
      }
      var result = process(response.data.data, this.state.dataState);
      this.setState({mappings:response.data.data,result:result,  loading:false ,refreshText:'', isAlphabetical: this.isAlphabetical(result.data)});
    }).catch(err=>{
      console.log(err);
      this.setState({mappings:[], loading:false, refreshText:''});
    });
  }

  isAlphabetical(arr) {
    // var arr = this.state.mappings
    const original = arr.map(item => item.MemberCode);
    const sorted = [...original].sort((a, b) => a.localeCompare(b));

    return original.every((val, i) => val === sorted[i]);
  }

  checkPositions(){
    const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    
    this.setState({addAccountMappingLoading:true, addAccountMappingText:'Loading...'});

    var payload ={
      company:this.props.user.company,
    }

    axios.post('api/checkForPositions' , payload , {headers}).then(response=>{
      var hasPositions = false
      if (response.data.result){
        hasPositions = true
      }
      this.setState({hasPositions: hasPositions, addAccountMappingLoading:false, addAccountMappingText:'Add Account Mapping'})
      
    }).catch(err=>{
      console.log(err);
      this.setState({hasPositions: false, addAccountMappingLoading:false, addAccountMappingText:'Add Account Mapping'});
    });
  }


  clearState(){
    this.setState({ mappings:[], result:[], unsavedChanges: false });
  }


  createCell(cell){
    if(cell.rowType==='data'){
      return (
          <div>
          
          <Button icon="trash" onClick = {(event) => this.deleteHouseholdMapping(event, cell)}>Delete?</Button>
          {/* <Button icon="trash" onClick = {(event) => {  }}>Delete?</Button> */}
          </div>

      );
    }
    else{
      return (
        <></>
      );
    }
  }

  moveItem(direction) {
    const newArr = [...this.state.mappings]; // Make a shallow copy
    var index = -1

    for (let i = 0; i < newArr.length; i++) {
      if (newArr[i].selected) {
        index = i;
        break
      }
    }

    if (index < 0 || index >= newArr.length) {

    }
    else{
      const item = newArr[index];
    newArr.splice(index, 1); // Remove the item
    

    switch (direction) {
      case 'up':
        if (index > 0) newArr.splice(index - 1, 0, item);
        else newArr.splice(index, 0, item); // Put it back if invalid
        break;
      case 'down':
        if (index < newArr.length) newArr.splice(index + 1, 0, item);
        else newArr.push(item); // Put it at end if invalid
        break;
      case 'top':
        newArr.unshift(item);
        break;
      case 'bottom':
        newArr.push(item);
        break;
      default:
        newArr.splice(index, 0, item); // Restore item if direction is invalid
        break;
    }

    for (let i = 0; i < newArr.length; i++) {
      newArr[i].MemberOrder = i + 1; // Or i if you want 0-based order
    }

    var newDataState = {...this.state.dataState}
    newDataState.sort = null;//remove sort so it doesn't override the new order

    var result = process(newArr, newDataState);
    this.setState({mappings:newArr,result:result, isAlphabetical: false, unsavedChanges: true});
    this.forceUpdate();
    }

    

  }



  deleteHouseholdMapping(e, cell){
    var mappings = this.state.mappings.slice();
    var index = mappings.findIndex(x=>{
      return (x.id===cell.dataItem.id);
    });

    //verify deletion
    const confirm = window.confirm("Are you sure you want to delete this Mapping? (" + cell.dataItem.MemberCode + ")" );

    if(confirm===true){
      var newArr = [...this.state.mappings]

      newArr.splice(index, 1);

      var newDataState = {...this.state.dataState}
      newDataState.sort = null;//remove sort so it doesn't override the new order

      var result = process(newArr, newDataState);
      this.setState({mappings:newArr,result:result, isAlphabetical: false, unsavedChanges: true});
      this.forceUpdate();
    }
  }

  onCloseModal = () => {
    this.clearState();
  }


  changeDataState = (e)=>{
    var newData = process(this.state.mappings, e.dataState);
    this.setState({dataState:e.dataState, result:newData});
  }

  addAccount = (account) => {
    var newAccount = {
      MemberCode: account.account, 
      MemberName: account.accountName,
      MemberType: 'Portfolio', 
      MemberOrder: this.state.mappings.length, 
    }

    const newArr = [...this.state.mappings]; // Make a shallow copy

    newArr.push(newAccount)

    var newDataState = {...this.state.dataState}
    newDataState.sort = null;//remove sort so it doesn't override the new order

    var result = process(newArr, newDataState);
    this.setState({mappings:newArr,result:result, unsavedChanges: true});
    this.forceUpdate();


  };

  changeAlphaSort(e){
    var isAlphabetical = e.target.value

    var newArr = [...this.state.mappings]; // Make a shallow copy

    if (isAlphabetical){
      newArr = [...newArr].sort((a, b) => a.MemberCode.localeCompare(b.MemberCode));
    }
    else{
      newArr = [...newArr].sort((a, b) => a.MemberOrder - b.MemberOrder);
    }

    // newArr.push(newAccount)

    var newDataState = {...this.state.dataState}
    newDataState.sort = null;//remove sort so it doesn't override the new order

    var result = process(newArr, newDataState);
    this.setState({mappings:newArr,result:result,isAlphabetical: isAlphabetical, unsavedChanges: true});
    this.forceUpdate();

  }

  onFilterChange = (e) => {
    this.setState({ result: filterBy(this.state.mappings, e.filter), gridFilter: e.filter });
  }


  checkUnsaved(cb){
    if (this.state.unsavedChanges){
      var answer = window.confirm("You have unsaved changes. Close anyway?");
      if (answer) {
          cb(true)
      }
      else {
        cb(false)
      }      
    }
    else{
      cb(true)
    }
  }

  formatDate(d) {

      const day = String(d.getUTCDate()).padStart(2, '0');
      const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const year = d.getUTCFullYear();
  
      return `${month}/${day}/${year}`;
  
    }

  onSave(cb) {
    if (window.confirm('Save changes?')) {
      // this.setState({ refreshText: 'Loading...' })
      var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      var newGroup = [...this.state.mappings]

      for(let i = 0; i < newGroup.length; i++){
        newGroup[i].MemberOrder = i + 1
        newGroup[i].date = this.formatDate(new Date());
        newGroup[i].GroupCode = this.props.dataRow.GroupCode;
        newGroup[i].Consolidated = newGroup[i].MemberType === 'Portfolio' ? null : newGroup[i].MemberType === 'Consolidated Group' ? 'y' : 'n'
      }

      var payload = {
        company: this.props.user.company,
        household: this.props.dataRow.GroupCode,
        newGroup: newGroup,
      };

      console.log(payload)


      axios.post('api/groupMembershipEntitySave', payload, { headers }).then(response => {
        if (response.data.code === 200){
          cb(true)
        }
        else{
          cb(false)
          alert("Error Saving Group")
        }

      })
        .catch(err => {
          alert("Error Saving Group")
          console.error(err);
        })
    }
  }


  render() {
    return(
    
      <Popup closeOnDocumentClick={false} trigger={this.props.button} onOpen={(e) => { this.getHouseholdMappings(); this.checkPositions();}} onClose={(event) => { this.clearState(); }} overlayStyle={{ zIndex: 5 }}  modal>
          {close => (
            <div className="modal">
            <Button className="close" icon="close" onClick={(e) => { this.checkUnsaved((cb) => {if (cb) {close()}})  }} />


            <div className="header" align="left">
                Edit Household Accounts
              </div>

            <div className='houseMappingList'>
                <Grid data={this.state.result}
                    selectedField='selected'
                    sortable={false}
                    filterable={true}
                    onFilterChange={this.onFilterChange}
                    filter={this.state.gridFilter}
                    onSelectionChange={(e) => this.selectionChange(e, this.state.mappings)}
                    onRowClick={(e) => this.selectionChange(e, this.state.mappings)}
                    onDataStateChange={this.changeDataState}
                    {...this.state.dataState}>
                <GridNoRecords>
                  {this.state.loading && 'Loading...'}
                  {!this.state.loading && 'No records available'}
                </GridNoRecords>
                <GridToolbar>
                <strong>Current Accounts Mapped</strong>
                
                <Button icon='refresh' title='Refresh' onClick={(e)=>this.getHouseholdMappings()}>{this.state.refreshText}</Button>
                
                {/* {this.state.addAccountMappingLoading &&
                  <Button className='docButton' icon='plus' disabled={true}>Loading...</Button>
                } */}
                {!this.state.addAccountMappingLoading &&
                  <>
                    {this.state.hasPositions &&
                      <AddHouseholdAccount refresh={this.refresh} addAccount={this.addAccount} household={this.props.dataRow.GroupCode} user={this.props.user} idToken={this.props.idToken} company={this.props.user.company} disabled={this.state.addAccountMappingLoading}  button={<Button className='docButton' icon='plus' onClick={(e)=>this.getHouseholdMappings()   }  >Add Account Mapping</Button>} />
                    }
                    {!this.state.hasPositions &&
                      <AddHouseholdAccountNoPositions refresh={this.refresh} addAccount={this.addAccount} household={this.props.GroupCode} user={this.props.user} idToken={this.props.idToken} company={this.props.user.company} disabled={this.state.addAccountMappingLoading}  button={<Button className='docButton' icon='plus' onClick={(e)=>this.getHouseholdMappings()   }  >Add Account Mapping</Button>} />
                    }
                  </>
                }
                
                

                </GridToolbar>
                <GridToolbar>
                  <Button icon='caret-alt-to-top' disabled={!this.state.fileSelected || this.state.gridFilter} title='Top' onClick={(e)=>this.moveItem('top')}>{''}</Button>
                <Button icon='arrow-up' disabled={!this.state.fileSelected || this.state.gridFilter} title='Up' onClick={(e)=>this.moveItem('up')}>{''}</Button>
                <Button icon='arrow-down' disabled={!this.state.fileSelected || this.state.gridFilter} title='Down' onClick={(e)=>this.moveItem('down')}>{''}</Button>
                <Button icon='caret-alt-to-bottom' disabled={!this.state.fileSelected || this.state.gridFilter} title='Bottom' onClick={(e)=>this.moveItem('bottom')}>{''}</Button>
                <span>{'Alphabetical Sort: '}</span><Switch
                                name={'alphabetical'}
                                disabled={this.state.gridFilter}
                                checked={this.state.isAlphabetical}
                                onChange={(e) => this.changeAlphaSort(e)}
                            />
                </GridToolbar>
                    <GridColumn width='50px' field="selected" filterable={false} headerClassName='gridHeader' headerSelectionValue={this.state.mappings.findIndex(dataItem => dataItem.selected === false) === -1} />
                    <GridColumn headerClassName='gridHeader' width='200' field='MemberCode' title='Account/Group'/>
                    <GridColumn headerClassName='gridHeader' width='200' field='MemberType' title='Member Type'/>
                    <GridColumn headerClassName='gridHeader' field='MemberName' title='Name'/>
                    <GridColumn headerClassName='gridHeader' width='90' filterable={false} editable={false} cell={(props) => this.createCell(props)}/>
                </Grid>
                {this.state.loading && <GridLoading/>}
            </div>

            
            <div className="actions">              
                <Button className="button" onClick={() => { this.checkUnsaved((cb) => {if (cb) {close()}})  }}>
                  Close
                </Button>

                <Button className="upload"
                  //onClick={(e) => this.savePackage((callback) => { if (callback) { close(); this.clearState(); } })}>
                  disabled={this.state.gridFilter || this.state.mappings.length === 0}
                  onClick={(e) => 
                  {
                     this.onSave((cb) => {if (cb) {close()}})  
                  }}>


                  Save Changes
                </Button>

              </div>
        
        
              </div>
          )}
        </Popup>

    );
  }

}


export default HouseholdAccounts;